$(function () {
  $('*[data-modal-auto-show]').modal('show');
});